import { setup as setupAnimatedHeight } from "./animated-height";

export function setup(storeNamespace) {
	setupAnimatedHeight(storeNamespace);
}
